module.exports = __webpack_public_path__ + "media/images/price-increase-mobile-f8528da200052b03b63d98076760ab58.png";